function filterOidcClients(oidcClients, oidcFilters) {
  let filters = oidcFilters;
  let oc = oidcClients;
  if (filters == null) {
    return oc;
  }
  if (!Array.isArray(filters)) {
    filters = [filters];
  }
  if (Array.isArray(oidcFilters)) {
    oc = oc.filter(c => {
      for (let n = 0; n < oidcFilters.length; n++) {
        if (oidcFilters[n] === c.alias) {
          return true;
        }
        if (typeof oidcFilters[n] === 'object' && oidcFilters[n]) {
          // eslint-disable-next-line security/detect-non-literal-regexp
          const rx = new RegExp(oidcFilters[n].regex);
          if (rx.test(c.alias)) {
            return true;
          }
        }
      }
      return false;
    });
  }
  return oc;
}
export default {
  filterOidcClients
};